import { useState, useEffect, useCallback, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';

const POLL_INTERVAL = 30000;

/**
 * Shared hook that polls GET /api/dashboard/navbar-status once every 30s,
 * replacing per-widget polling in GlobalTimerWidget, NotificationBell, and SupportChatWidget.
 */
export default function useNavbarStatus() {
  const { user } = useAuth();
  const [timers, setTimers] = useState([]);
  const [notificationUnreadCount, setNotificationUnreadCount] = useState(0);
  const [supportChatEnabled, setSupportChatEnabled] = useState(false);
  const [supportChatUnreadCount, setSupportChatUnreadCount] = useState(0);
  const pollRef = useRef(null);

  const fetchStatus = useCallback(async () => {
    if (!user) return;
    try {
      const res = await api.get('/dashboard/navbar-status');
      const d = res.data;
      setTimers(d.timers || []);
      setNotificationUnreadCount(d.notification_unread_count || 0);
      setSupportChatEnabled(d.support_chat_enabled ?? false);
      setSupportChatUnreadCount(d.support_chat_unread_count || 0);
    } catch {
      // endpoint unavailable — leave state unchanged
    }
  }, [user]);

  useEffect(() => {
    if (!user) return;
    fetchStatus();
    pollRef.current = setInterval(fetchStatus, POLL_INTERVAL);
    return () => clearInterval(pollRef.current);
  }, [fetchStatus, user]);

  return {
    timers,
    notificationUnreadCount,
    supportChatEnabled,
    supportChatUnreadCount,
    refetchNavbarStatus: fetchStatus,
  };
}
